import { lazy } from "react";
import { Paths } from "./Paths";

export const abAccountingRoutes = [
  {
    path: Paths.hdfcStatementUpload,
    ComponentIn: lazy(
      () => import("Components/AbAccounting/UploadJobs/HdfcStatementUpload/HdfcStatementUpload")
    )
  },
  {
    path: Paths.hdfcStatementList,
    ComponentIn: lazy(
      () => import("Components/AbAccounting/UploadJobs/HdfcStatementUpload/HdfcStatementList")
    )
  },
  {
    path: Paths.hdfcResponseUpload,
    ComponentIn: lazy(
      () => import("Components/AbAccounting/UploadJobs/HdfcResponseUpload/HdfcResponseList")
    )
  },
  {
    path: Paths.hdfcResponseUploadDetails,
    ComponentIn: lazy(
      () => import("Components/AbAccounting/UploadJobs/HdfcResponseUpload/HdfcResponseUpload")
    )
  },
  {
    path: Paths.abBusinessInfo,
    ComponentIn: lazy(() => import("Components/AbAccounting/AbBusinessInfo/AbBusinessInfoIndex"))
  },
  {
    path: Paths.accountSummary,
    ComponentIn: lazy(() => import("Components/AbAccounting/AccountSummary/AccountSummary"))
  },
  {
    path: Paths.completeLedger,
    ComponentIn: lazy(() => import("Components/AbAccounting/CompleteLedger/CompleteLedger"))
  },
  {
    path: Paths.abRemainingBalance,
    ComponentIn: lazy(() => import("Components/AbAccounting/AbRemainingBalance/AbRemainingBalance"))
  },
  {
    path: Paths.panCases,
    ComponentIn: lazy(() => import("Components/AbAccounting/ABPan/ABPan"))
  },
  {
    path: Paths.abTdsTracker,
    ComponentIn: lazy(() => import("Components/AbAccounting/AbTdsTracker/AbTdsTracker"))
  },
  {
    path: Paths.reversePayment,
    ComponentIn: lazy(() => import("Components/AbAccounting/ReversePayment/ReversePaymentList"))
  },
  {
    path: Paths.reversePaymentUpload,
    ComponentIn: lazy(() => import("Components/AbAccounting/ReversePayment/ReversePayment"))
  },
  {
    path: Paths.abHolds,
    ComponentIn: lazy(() => import("Components/AbAccounting/AbHolds/AbHolds"))
  },
  {
    path: Paths.commissionCycle,
    ComponentIn: lazy(() => import("Components/AbAccounting/CommissionCycle/CommissionCycleList"))
  },
  {
    path: Paths.cashBonusCycle,
    ComponentIn: lazy(() => import("Components/AbAccounting/CashBonusCycle/CashBonusCycleList"))
  },
  {
    path: Paths.businessProcessing,
    ComponentIn: lazy(
      () => import("Components/AbAccounting/BusinessProcessing/BusinessProcessingList")
    )
  },
  {
    path: Paths.exportJobsList,
    ComponentIn: lazy(() => import("Components/AbAccounting/Common/ExportJobsList"))
  },
  {
    path: Paths.gstBusinessProcessing,
    ComponentIn: lazy(
      () => import("Components/AbAccounting/GstBusinessProcessing/GstBusinessProcessingList")
    )
  },
  {
    path: Paths.exportGstJobsList,
    ComponentIn: lazy(() => import("Components/AbAccounting/Common/ExportJobsList"))
  },
  {
    path: Paths.beneficiaryDetails,
    ComponentIn: lazy(
      () => import("Components/AbAccounting/BeneficiaryDetails/BeneficiaryDetailsList")
    )
  },
  {
    path: Paths.exportBeneficiaryJobsList,
    ComponentIn: lazy(() => import("Components/AbAccounting/Common/ExportJobsList"))
  },
  {
    path: Paths.bankBookSummary,
    ComponentIn: lazy(() => import("Components/AbAccounting/BankBook/BankBookList"))
  },
  {
    path: Paths.bankBookDetails,
    ComponentIn: lazy(() => import("Components/AbAccounting/BankBook/HdfcBankBookDetails"))
  },
  {
    path: Paths.sbiBankBookDetails,
    ComponentIn: lazy(() => import("Components/AbAccounting/BankBook/SbiBankBookDetails"))
  },
  {
    path: "bank_book_summary/:chequeNo",
    ComponentIn: lazy(() => import("Components/AbAccounting/BankBook/SbiBankBookDetails"))
  },
  {
    path: Paths.masterRcmBank,
    ComponentIn: lazy(() => import("Components/AbAccounting/MasterRcmBank/MasterRcmBankList"))
  },
  {
    path: Paths.abInvoices,
    ComponentIn: lazy(() => import("Components/AbAccounting/AbInvoices/AbInvoicesList"))
  },
  {
    path: Paths.sapBusinessReport,
    ComponentIn: lazy(() => import("Components/AbAccounting/SAP/Business/SapBusinessReport"))
  },
  {
    path: Paths.sapPaymentReport,
    ComponentIn: lazy(() => import("Components/AbAccounting/SAP/Payment/SapPaymentReport"))
  },
  {
    path: Paths.sapTdsReport,
    ComponentIn: lazy(() => import("Components/AbAccounting/SAP/Tds/SapTdsReport"))
  },
  {
    path: Paths.exportJobs,
    ComponentIn: lazy(() => import("Components/AbAccounting/ExportJobs/ExportJobsList"))
  },
  {
    path: Paths.masterBusinessRemark,
    ComponentIn: lazy(
      () => import("Components/AbAccounting/MasterBusinessRemark/MasterBusinessRemark")
    )
  },
  {
    path: Paths.abLoanManager,
    ComponentIn: lazy(() => import("Components/AbAccounting/AbLoanManager/AbLoanManager"))
  }
];
